"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUserSettingsSystemsSummaryMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.setUserSettingsSystemsSummaryMutation = (0, graphql_tag_1.default) `
  mutation SetUserSettingsSystemsSummary(
    $newsettings: UserSettingsSystemsSummaryInputType!
  ) {
    setUserSettingsSystemsSummary(userSettingsSystemsSummary: $newsettings) {
      id
    }
  }
`;
//# sourceMappingURL=set-user-settings-systems-summary.js.map